
// get order items
export const GET_ORDER_ITEMS_LOADING = "order/items/get/laoding";
export const GET_ORDER_ITEMS_SUCCESS = "order/items/get/success";
export const GET_ORDER_ITEMS_ERROR = "order/items/get/error";

// add item to cart
export const ADD_ORDER_ITEM_TO_LOADING = "order/items/add/laoding";
export const ADD_ORDER_ITEM_TO_SUCCESS = "order/items/add/success";
export const ADD_ORDER_ITEM_TO_ERROR = "order/items/add/error";


// REMOVE order items
export const REMOVE_ORDER_ITEMS_LOADING = "order/items/remove/laoding";
export const REMOVE_ORDER_ITEMS_SUCCESS = "order/items/remove/success";
export const REMOVE_ORDER_ITEMS_ERROR = "order/items/remove/error";